<div class="works">
  <div class="filter-button">
    <a class="spen-util-link" (click)="doFilterWork()"
      ><i class="fa fa-search"></i>{{ !!queryParams['keyword'] ? '検索条件を変更' : '検索' }}</a
    >
  </div>
  @if (queryParams['keyword']) {
    <div class="filtered-work">
      <span class="name">検索条件：{{ queryParams['keyword'] }}</span>
      <a class="spen-util-link remove-filter" (click)="removeWorkFilter()">解除</a>
    </div>
  }

  <div class="work-list">
    @if (dataLoaded) {
      @if (works.length > 0) {
        <div class="list-amount">
          <span>{{ worksCount }}件</span>
        </div>
        <div class="content">
          <ul class="detail-flex-list">
            @for (work of works; track work.id) {
              <li class="list-item" (click)="onClickWork(work)">
                <a class="list-item-info">
                  <div class="icon">
                    <i class="fa fa-file-text-o"></i>
                  </div>
                  <div class="text-info">
                    <p class="text-badge">
                      @if (!work.is_read) {
                        <span class="spen-mod-badge is-red spen-util-link">NEW</span>
                      }
                      <span class="spen-mod-badge default-detail-badge">{{ answerState(work) }}</span>
                      <span class="time-detail">{{ work.created_at | date: 'yyyy/MM/dd' }}</span>
                    </p>
                    <p class="title">{{ work.title }}</p>
                    <p class="author">
                      {{ work.create_user.name }}先生 <span class="note-album">配信先: {{ work.album_title || work.space.name }}</span>
                    </p>
                  </div>
                </a>
                <a class="list-item-icon"><i class="fa fa-chevron-right"></i></a>
              </li>
            }
          </ul>
          <div class="block-footer">
            @if (showPagination) {
              <div class="pagination">
                <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="null-content">
          <p class="text">課題はありません。</p>
        </div>
      }
    } @else {
      <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
    }
  </div>
  @if (!isMobileApp) {
    <a href="{{ classiUrl }}" class="spen-mod-btn prev-button">ホームへ戻る</a>
  }
</div>

@if (showFilterModal) {
  <app-work-filter-modal (eventModalFilter)="eventModalFilter($event)" [keyword]="queryParams['keyword']"></app-work-filter-modal>
}
